module.exports = __webpack_public_path__ + "img/girl2.b46d3b36.jpg";